<template>
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M8.0001 1.72559C4.31821 1.72559 1.33344 4.53477 1.33344 8.00009C1.33344 11.4654 4.3182 14.2746 8.0001 14.2746C11.682 14.2746 14.6667 11.4654 14.6667 8.00009C14.6667 4.53477 11.682 1.72559 8.0001 1.72559Z" fill="currentColor"/>
        <path d="M8.00024 10.8234V8.47046" stroke="white" stroke-width="1.5" stroke-linecap="round"/>
        <path d="M8.00012 4.23532C7.44784 4.23532 7.00012 4.6567 7.00012 5.1765C7.00012 5.6963 7.44784 6.11768 8.00012 6.11768C8.55241 6.11768 9.00012 5.6963 9.00012 5.1765C9.00012 4.6567 8.55241 4.23532 8.00012 4.23532Z" fill="white"/>
    </svg>
</template>
